import { render, staticRenderFns } from "./TenantProject.vue?vue&type=template&id=1b0fb776&"
import script from "./TenantProject.vue?vue&type=script&lang=js&"
export * from "./TenantProject.vue?vue&type=script&lang=js&"
import style0 from "./TenantProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0fb776')) {
      api.createRecord('1b0fb776', component.options)
    } else {
      api.reload('1b0fb776', component.options)
    }
    module.hot.accept("./TenantProject.vue?vue&type=template&id=1b0fb776&", function () {
      api.rerender('1b0fb776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/TenantProject.vue"
export default component.exports